module.exports = __webpack_public_path__ + "img/hero_image.4ae9570d.jpeg";